export default [
    {
        label: 'Autre',
        value: 'other'
    },
    {
        label: 'Notice',
        value: 'notice'
    },
    {
        label: 'Certification',
        value: 'certif'
    },
]